export default __webpack_public_path__ + "static/media/close.90f2799d.svg";